var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 16,
    viewBox: "0 0 100 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_2025 1",
    clipPath: "url(#clip0_5134_14267)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.8056 10.1957C17.8056 11.3058 17.8507 12.6177 16.3646 12.6177C14.8785 12.6177 14.9028 11.1736 14.9028 10.0635V0.222702H11.9757V11.4867C11.9757 14.107 13.9028 15.2866 16.3195 15.2866C17.7813 15.2866 19.4445 14.8865 20.2431 13.5328C20.6875 12.7777 20.7292 12.1096 20.7292 11.2675V0.222702H17.8021V10.1992L17.8056 10.1957Z",
    fill: "#FF006E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.2362 8.97433H27.8299V6.17659H25.2362V2.9752H28.1841V0.222702H22.3091V15.0396H28.2257V12.308H25.2362V8.97433Z",
    fill: "#FF006E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M32.7326 8.97433H35.3264V6.17659H32.7326V2.9752H35.6805V0.222702H29.8055V15.0396H35.7257V12.308H32.7326V8.97433Z",
    fill: "#FF006E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M43.4862 7.17529C43.4862 7.84341 43.5764 8.50804 43.7084 9.17616L40.073 0.222702H37.3021V15.0396H40.2292V7.79817C40.2292 7.24141 40.1841 6.66376 40.073 6.11048L43.7084 15.0396H46.4584V0.222702H43.4896V7.17529H43.4862Z",
    fill: "#FF006E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M50.9167 4.06438C50.9167 3.19791 51.5139 2.62027 52.3785 2.62027C53.2431 2.62027 53.8854 3.06568 54.4826 3.57721V0.709874C53.6181 0.222706 52.8854 0 51.8889 0C49.3854 0 48.0312 2.04263 48.0312 4.37756C48.0312 6.53154 49.0937 7.59983 50.7569 8.75511C51.2431 9.08917 52.066 9.57634 52.3299 10.1331C52.441 10.3767 52.4861 10.6203 52.4861 10.8882C52.4861 11.9113 51.7535 12.5307 50.7569 12.5307C49.9375 12.5307 49.25 12.1757 48.5833 11.7303V14.5281C49.3368 15.0396 50.2222 15.2832 51.1319 15.2832C53.8125 15.2832 55.3437 13.2614 55.3437 10.7073C55.3437 6.57677 50.9097 6.61853 50.9097 4.06438H50.9167Z",
    fill: "#FF006E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M61.3889 4.06438C61.3889 3.19791 61.9861 2.62027 62.8507 2.62027C63.6702 2.62027 64.3577 3.06568 64.9583 3.57721V0.709874C64.0938 0.222706 63.3611 0 62.3646 0C59.8611 0 58.507 2.04263 58.507 4.37756C58.507 6.53154 59.5695 7.59983 61.2327 8.75511C61.7188 9.08917 62.5417 9.57634 62.8056 10.1331C62.9167 10.3767 62.9618 10.6203 62.9618 10.8882C62.9618 11.9113 62.2292 12.5307 61.2327 12.5307C60.4132 12.5307 59.7257 12.1757 59.059 11.7303V14.5281C59.8125 15.0396 60.6979 15.2832 61.6076 15.2832C64.2917 15.2832 65.8195 13.2614 65.8195 10.7073C65.8195 6.57677 61.3854 6.61853 61.3854 4.06438H61.3889Z",
    fill: "#FF93B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M74.9584 0.222702L73.7848 8.97433L72.3438 0.222702H68.4861L67.2014 15.0396H70.3264L70.7917 4.37755L70.9688 6.11048C71.0348 6.86559 71.191 7.59982 71.3473 8.33057L72.7223 15.0396H74.9618L76.2709 7.79817C76.4723 6.66376 76.6493 5.53284 76.7153 4.37755L77.4479 15.0396H80.441L78.9063 0.222702H74.9618H74.9584Z",
    fill: "#FF93B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M84.941 0.222702H82.0139V15.0396H84.941V0.222702Z",
    fill: "#FF93B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M89.4444 0.222702H86.5173V15.0396H92.5034V12.2627H89.4444V0.222702Z",
    fill: "#FF93B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M97.0069 12.308V8.97433H99.6007V6.17659H97.0069V2.9752H99.9548V0.222702H94.0798V15.0396H100V12.308H97.0069Z",
    fill: "#FF93B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M10.0521 14.288L9.12847 12.997C10 11.6085 10.3958 10.0565 10.3958 7.7773C10.3958 5.73467 10.1285 3.13528 8.51042 1.46846C7.69097 0.622879 6.49653 0 5.16667 0C3.99306 0 2.77431 0.487168 1.88542 1.39887C0.288194 2.99957 0 5.46325 0 7.57547C0 10.0844 0.378472 12.2836 1.88542 13.8182C2.86111 14.8169 4.01389 15.2832 5.47569 15.2832C6.22569 15.2832 6.82986 15.1544 7.47222 14.6846L8.25 15.7703L8.41667 16L9.86806 14.9561L10.1875 14.7264L10.309 14.6394L10.0556 14.288H10.0521ZM5.23264 12.4646C4.74653 12.4646 4.41319 12.2662 4.14583 11.9774C3.74653 11.532 3.125 10.4672 3.125 7.48847C3.125 5.93301 3.19097 4.08873 4.23264 3.09004C4.5 2.8221 4.80903 2.66899 5.22917 2.66899C5.69444 2.66899 6.00347 2.91257 6.25 3.18051C7.20486 4.26968 7.3125 6.20096 7.3125 7.64506C7.3125 8.62636 7.27778 9.32927 7.11806 10.1992L6.39236 9.1866L4.5 10.5472L5.76736 12.3184C5.59722 12.4263 5.4375 12.4646 5.22569 12.4646H5.23264Z",
    fill: "#FF006E"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5134_14267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.02f43fe22807ae1f6b29b318e427717c.svg";
export { ForwardRef as ReactComponent };